import React, { useContext, useEffect, useState } from 'react';
import classNames from 'classnames';
import { ICollectionIntegration } from '../../../../../types';
import { errToString } from '../../../../../utils/errors';
import CollectionConnectDataNotion from '../../../../CollectionSettingsComponents/CollectionConnectDataNotion';
import styles from '../CollectionSettings.module.css';
import { INTEGRATION_ASSETS } from '../../../constants';
import SelectIntegrations from '../../../../CollectionSetupFlow/ConnectData/SelectIntegrations';
import {
  CollectionSettingsDataContext,
  CollectionSettingsIntegrationContext,
  CollectionSettingsIntegrationDispatchContext,
} from '../contextProvider';

function ConnectDataNotion({ onGoNext }: {
  onGoNext: () => void
}) {
  const currentIntegration = ICollectionIntegration.NOTION;
  const integration = useContext(CollectionSettingsIntegrationContext);
  const {
    connectedIntegrations,
    seterr,
    useIntegrationOAuth,
    loading,
    collectionData,
    err,
  } = useContext(CollectionSettingsDataContext);
  const setSettingsIntegration = useContext(CollectionSettingsIntegrationDispatchContext);

  const [connected, setconnected] = useState(false);
  const [currentApp, setcurrentApp] = useState(null);

  useEffect(() => {
    const currApps = connectedIntegrations?.filter((i) => i.name === currentIntegration);
    setconnected(currApps?.length > 0);
    if (currApps?.length > 0) {
      setcurrentApp(currApps?.[0]);
    }
  }, [collectionData, connectedIntegrations]);

  const useNotion = async (connect: boolean, code: string) => {
    seterr(null);
    try {
      await useIntegrationOAuth(connect, code);
      setSettingsIntegration(currentIntegration);
      onGoNext();
    } catch (e) {
      seterr(errToString(e));
    }
  };
  return (

    <div className={classNames(styles.pageContainer, 'is-flex is-flex-direction-column is-align-items-center is-justify-content-center has-fullwidth')}>

      <div className={classNames(styles.containerMaxHeight, 'p-6 pt-3 is-flex is-flex-direction-row is-align-items-flex-start is-justify-content-space-between')}>
        <div className={styles.containerItem}>
          <SelectIntegrations />
          <CollectionConnectDataNotion
            useNotion={useNotion}
            showNextButton={false}
            loading={loading}
            connected={connected}
            currentApp={currentApp}
            showChangeType="link"
            err={err}
          />
        </div>
        {INTEGRATION_ASSETS[integration]?.connectImage
        && (
          <div className={classNames(styles.containerItem, 'is-flex is-align-items-center is-justify-content-center')} style={{ height: '100%' }}>
            <img src={INTEGRATION_ASSETS[integration].connectImage} className={styles.connectImage} alt="Connect Data Instructions" />
          </div>
        )}
      </div>
    </div>
  );
}

export default ConnectDataNotion;
